var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserLayout',{attrs:{"pageTitle":"Gestione clienti"},scopedSlots:_vm._u([{key:"page-content",fn:function(props){return [_c('FrmManageClients')]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }